import { memo } from "react";
import SwipeIcon from "./images/icons/swipe.svg?react";
import CloseIcon from "@/common/images/icons/x.svg?react";
import "./ScrollMore.scss";

interface IScrollMore {
  subredditName?: string;
  onClose: () => void;
}

export const ScrollMore = memo(({ subredditName, onClose }: IScrollMore) => {
  return (
    <div className="scrollMore">
      <div className="swipeIcon">
        <SwipeIcon />
      </div>
      <span className="text">
        {subredditName ? (
          <>
            Scroll to see more Videos from <b>r/{subredditName}</b>
          </>
        ) : "Scroll to see more Videos"}
      </span>
      <button className="closeBtn" onClick={onClose}>
        <CloseIcon />
      </button>
    </div>
  );
});
